import { Injectable } from '@angular/core';

import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';

import 'rxjs/add/observable/fromPromise';

import { AuthenticationService } from '../authentication/authentication.service';
import { EntityManagerProvider } from '../entity-manager-provider/entity-manager-provider';
import { TranslateService } from 'ng2-translate';
import { InformesService } from '../informes/informes.service';
import { forEach } from '@angular/router/src/utils/collection';
import { IdiomaService } from '../idioma/idioma.service';
import { BehaviorSubject } from '../../../../node_modules/rxjs';
import { Predicate } from 'breeze-client';
import { textChangeRangeIsUnchanged } from 'typescript';



const PREFERENCIAS_RUTAS_INICIALES = {
	Dashboard_menu: '/dashboard',
	Contenidos_menu: '/contenidos',
	RutaSugerida_menu: '/rutas-sugeridas',
	Mapas_menu: '/mapas',
	Mensajes_menu: '/mensajes',
	Ajustes_menu: '/entidades',
	Balizas_menu: '/balizas',
	Diagnostico_menu: '/Conexion',
	Informes_menu: '/informes',
	Encuestas_menu: '/encuestas'
};

@Injectable()
export class PermisosService {

	[x: string]: any;

	// store the URL so we can redirect after logging in
	redirectUrl: string;

	menuLateralModel: any = [];
	private menuSource = new BehaviorSubject(this.menuLateralModel);
	currentMenu = this.menuSource.asObservable();

	changeMenu(menu){
		this.menuSource.next(menu);
	}

	construirMenu(){
		const userId = this.authService.getIdUsuario();
		this.model = [];
		const that = this;

		return this.entityManager.getFUNCIONALIDADESbyUSUARIO(userId)
		.then(function(funcionalidades){
			return that.getMenu(funcionalidades);
		})
		.then(function(menu){
			that.changeMenu(menu);
		});
	}

	constructor(private entityManager: EntityManagerProvider,
		private authService: AuthenticationService,
		private translate: TranslateService,
		private informeService: InformesService,
		private idiomaService: IdiomaService

		) {
	}

	/* MENU LATERAL */
	getMenu(funcionalidades){
		
		const that = this;
		const model = [];

		if (funcionalidades) {

			funcionalidades.sort(function(a, b) {
				const textA = a.FUNCIONALIDAD.OrdenMenu;
				const textB = b.FUNCIONALIDAD.OrdenMenu;
				return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
			});

			let opsTipologia = [];

			return this.obtenerTIPOLOGIA_CONTENIDO()
			.then(function(tipologias){
				opsTipologia = tipologias;

				opsTipologia = that.idiomaService.traducirTipologiasContenidoIdiomaNavegador(opsTipologia);
				funcionalidades.forEach(funcion => {
					if (funcion.FUNCIONALIDAD) {

						if (funcion.FUNCIONALIDAD.Nombre === Permisos.Dashboard_menu) {
							if (funcion.Tipo === 2) {
								model.push({
									label: that.translate.instant('MenuLateral.Dashboard'), // 'Dashboard'
									icon: 'iticon-tab-dashboard iticon-px32',
									routerLink: [PREFERENCIAS_RUTAS_INICIALES.Dashboard_menu]
								});
							}
						}
						else if (funcion.FUNCIONALIDAD.Nombre === Permisos.Mapas_menu) {
							if (funcion.Tipo === 2) {
								model.push({
									label: that.translate.instant('MenuLateral.Planos'), // 'Planos',
									icon: 'iticon-tab-ubicacion-contenido-en-mapa iticon-px32',
									routerLink: [PREFERENCIAS_RUTAS_INICIALES.Mapas_menu]
								});
							}
						}
						else if (funcion.FUNCIONALIDAD.Nombre === Permisos.Contenidos_menu) {
							if (funcion.Tipo === 2) {
								const items = [];
								const haySubmenu = opsTipologia.find(t => t.VisibilidadMenuLateral) !== undefined;
								if (haySubmenu){
									items.push({
										label: that.translate.instant('MenuLateral.Todos'), // 'todos los Contenidos'
										icon: '',
										routerLink: [PREFERENCIAS_RUTAS_INICIALES.Contenidos_menu, { idTipologia: that.translate.instant('MenuLateral.Todos')} ],
										root: false,
										visible: false,
										items: false
									});
									opsTipologia.forEach(element => {
										if (element.VisibilidadMenuLateral) {

											items.push(
												{
													label: element.Nombre, // 'Contenidos'
													icon: '',
													routerLink: [PREFERENCIAS_RUTAS_INICIALES.Contenidos_menu , { idTipologia: element.Id} ], // TODO: Ruta con iDTipologia
													root: false,
													visible: false,
													items: false
												}
											);

										}

									});
								}

								if (items.length !== 0) {
									// TODO: Traducir nombre tipologia
									model.push({
										label: that.translate.instant('MenuLateral.Contenidos'), // 'Contenidos'
										icon: 'iticon-tab-contenido iticon-px32',
										// routerLink: [PREFERENCIAS_RUTAS_INICIALES.Contenidos_menu],
										root: true,
										items: items
									});

								}
								else{
									model.push({
										label: that.translate.instant('MenuLateral.Contenidos'), // 'Contenidos'
										icon: 'iticon-tab-contenido iticon-px32',
										routerLink: [PREFERENCIAS_RUTAS_INICIALES.Contenidos_menu]
									});
								}

							}
						}
						else if (funcion.FUNCIONALIDAD.Nombre === Permisos.RutaSugerida_menu) {
							if (funcion.Tipo === 2) {
								model.push({
									label: that.translate.instant('MenuLateral.Rutas'), // 'Rutas sugeridas'
									icon: 'iticon-tab-ruta iticon-px32',
									routerLink: [PREFERENCIAS_RUTAS_INICIALES.RutaSugerida_menu]
								});
							}
						}
						else if (funcion.FUNCIONALIDAD.Nombre === Permisos.Mensajes_menu) {
							if (funcion.Tipo === 2) {
								model.push({
									label: that.translate.instant('MenuLateral.Mensajes'), // 'Mensajes'
									icon: 'iticon-tab-email iticon-px32',
									routerLink: [PREFERENCIAS_RUTAS_INICIALES.Mensajes_menu]
								});

							}
						}
						else if (funcion.FUNCIONALIDAD.Nombre === Permisos.Ajustes_menu) {
							if (funcion.Tipo === 2) {
								model.push({
									label: that.translate.instant('MenuLateral.Ajustes'), // 'Ajustes'
									icon: 'iticon-tab-settings iticon-px32',
									routerLink: [PREFERENCIAS_RUTAS_INICIALES.Ajustes_menu]
								});

							}
						}
						else if (funcion.FUNCIONALIDAD.Nombre === Permisos.Test_menu) {
							if (funcion.Tipo === 2) {
								model.push({
									label: that.translate.instant('MenuLateral.Diagnostico'), // 'Diagnostico'
									// icon: 'material-icons ui-icon-build',
									icon: 'iticon-diagnostico iticon-px32',
									routerLink: [PREFERENCIAS_RUTAS_INICIALES.Diagnostico_menu]
								});

							}
						}
						else if (funcion.FUNCIONALIDAD.Nombre === Permisos.Balizas_menu) {
							if (funcion.Tipo === 2) {
								model.push({
									label: that.translate.instant('MenuLateral.Balizas'), // 'Balizas'
									icon: 'iticon-nodo-baliza iticon-px32',
									routerLink: [PREFERENCIAS_RUTAS_INICIALES.Balizas_menu]
								});
							}
						}
						// TODO: Dar de alta el nuevo permiso en BBDD y agregar esta linea
						else if (funcion.FUNCIONALIDAD.Nombre === Permisos.Informes_menu) {
						// if (funcion.FUNCIONALIDAD.Nombre === Permisos.Dashboard_menu) {
							if (funcion.Tipo === 2) {
								model.push({
									label: that.translate.instant('MenuLateral.Informes'), // 'Informes'
									icon: 'iticon-noticia iticon-px32',
									routerLink: [PREFERENCIAS_RUTAS_INICIALES.Informes_menu]
								});
							}
						}
						else if (funcion.FUNCIONALIDAD.Nombre === Permisos.Encuestas_menu) {
							if (funcion.Tipo === 2) {
								model.push({
									label: that.translate.instant('MenuLateral.Encuestas'), // 'Encuestas'
									icon: 'iticon-tipologia-informacion iticon-px32',
									routerLink: [PREFERENCIAS_RUTAS_INICIALES.Encuestas_menu]
								});
							}
						}
					}

				});
				return model;
			});
		}
	}

	/*
    obtenerTipologias() {
        const that = this;
        const entityManager = that.entityManager;
        const idEspacio = that.authService.getIdEspacio();
        return entityManager.getTipologiasEspacio(idEspacio);
    }
	*/

	obtenerTIPOLOGIA_CONTENIDO(pre?) {
		const that = this;
		const entityManager = that.entityManager;
		const idEspacio = that.authService.getIdEspacio();
		let predicado =  new Predicate('IdEspacio', '==', idEspacio);

		if (pre) {
			predicado = predicado.and(pre);
		}

		const userId = this.authService.getIdUsuario();
		let permisos: Permisos;
		return this.getPermisosUsuario(userId)
		.then(function (perm){
			permisos = perm;
			return entityManager.getTIPOLOGIA_CONTENIDO(predicado, 'IDIOMAS.IDIOMA')
		})
		.then(function (entidades) {

			// that.tipologiasContenido = entidades;
			const tipologiasAux = [];
			entidades.forEach(tipologia => {
				if (tipologia.TipoUbicacion === null || tipologia.TipoUbicacion === 'ESTATICO') {
					tipologiasAux.push(tipologia);
				}
				else if (permisos.Gestion_Activos === 2) {
					tipologiasAux.push(tipologia);
				}
			});
			that.tipologiasContenido = tipologiasAux;

			if (that.tipologiasContenido && that.tipologiasContenido.length > 0) {
				that.tipologiasContenido.sort( (one: any, two: any) => {
					return one.Nombre > two.Nombre ? 1 : -1;
				});
			}

			return that.tipologiasContenido;
		});
	}
	obtenerTIPOLOGIA_SECCION(pre?) {
		const that = this;
		const entityManager = that.entityManager;
		const idEspacio = that.authService.getIdEspacio();
		let predicado =  new Predicate('IdEspacio', '==', idEspacio);
		const include = 'IDIOMAS.IDIOMA, SECCIONES';

		if (pre) {
			predicado = predicado.and(pre);
		}

		const userId = this.authService.getIdUsuario();
		let permisos: Permisos;
		return this.getPermisosUsuario(userId)
		.then(function (perm){
			permisos = perm;
			return entityManager.getTIPOLOGIA_SECCION(predicado, include)
		})
		.then(function (entidades) {
			console.log(entidades)
			// that.tipologiasContenido = entidades;
			const tipologiasSeccionAux = [];
			entidades.forEach(tipologia => {
			if (permisos.Gestion_Activos === 2) {
				tipologiasSeccionAux.push(tipologia);
				}
			});
			that.tipologiasSeccion = tipologiasSeccionAux;

			if (that.tipologiasSeccion && that.tipologiasSeccion.length > 0) {
				that.tipologiasSeccion.sort( (one: any, two: any) => {
					return one.Nombre > two.Nombre ? 1 : -1;
				});
			}

			return that.tipologiasSeccion;
		});
	}

	getPermisosUsuario(userId){

		return this.entityManager.getFUNCIONALIDADESbyUSUARIO(userId)
		.then(function(funcionalidades){
			const permisos = new Permisos(funcionalidades);
			return permisos;
		});

	}

	getRutaPaginaInicio(userId){
		const that = this;
		return this.entityManager.getFUNCIONALIDADESbyUSUARIO(userId)
		.then(function(funcionalidades){
			return that.getMenu(funcionalidades);
		})
		.then(function(menu){
			that.model = menu;
			const principal = that.model[0];
			return principal.routerLink;
		});
	}
}


export class Permisos {

	// Menu Lateral
	static readonly Dashboard_menu = 'Dashboard_menu';
	static readonly Mapas_menu = 'Mapas_menu';
	static readonly Contenidos_menu = 'Contenidos_menu';
	static readonly RutaSugerida_menu = 'RutaSugerida_menu';
	static readonly Noticias_menu = 'Noticias_menu';
	static readonly Mensajes_menu = 'Mensajes_menu';
	static readonly Ajustes_menu = 'Ajustes_menu';
	static readonly Balizas_menu = 'Balizas_menu';
	static readonly Test_menu = 'Test_menu';
	static readonly Informes_menu = 'Informes_menu';
	static readonly Encuestas_menu = 'Encuestas_menu';

	// Pantalla Plano
	static readonly Constante_Mapa_crear_plano = 'Mapa_crear_plano';
	static readonly Constante_Mapa_plano_nodo = 'Mapa_plano_nodo';
	static readonly Constante_Mapa_plano_seccion = 'Mapa_plano_seccion';
	static readonly Constante_Mapa_plano_contenido = 'Mapa_plano_contenido';
	static readonly Constante_Mapa_plano_conexion = 'Mapa_plano_conexion';
	static readonly Constante_Mapa_plano_balizas = 'Mapa_plano_balizas';
	static readonly Constante_Mapa_plano_Preview_por_Fecha = 'Mapa_plano_Preview_por_Fecha';

	static readonly Constante_Mapa_plano_nodo_formulario = 'Mapa_plano_nodo_formulario';
	static readonly Constante_Mapa_plano_seccion_formulario = 'Mapa_plano_seccion_formulario';
	static readonly Constante_Mapa_plano_contenido_formulario = 'Mapa_plano_contenido_formulario';
	static readonly Constante_Mapa_plano_conexion_formulario = 'Mapa_plano_conexion_formulario';
	static readonly Constante_Mapa_plano_baliza_formulario = 'Mapa_plano_baliza_formulario';

	static readonly Constante_Mapa_plano_cortar_conexion_formulario= 'Mapa_plano_cortar_conexion_formulario';
	static readonly Constante_Mapa_plano_eliminar_conexion_formulario = 'Mapa_plano_eliminar_conexion_formulario';
	static readonly Constante_Mapa_plano_baliza_password = 'Mapa_plano_baliza_password';

	// Pantalla Selector Plano
	static readonly Constante_Selector_Mapa_add_nivel = 'Selector_Mapa_add_nivel';
	static readonly Constante_Selector_Mapa_editar_nivel = 'Selector_Mapa_editar_nivel';
	static readonly Constante_Selector_Mapa_borrar_nivel = 'Selector_Mapa_borrar_nivel';

	static readonly Constante_Selector_Mapa_add_ala = 'Selector_Mapa_add_ala';
	static readonly Constante_Selector_Mapa_editar_ala = 'Selector_Mapa_editar_ala';
	static readonly Constante_Selector_Mapa_borrar_ala = 'Selector_Mapa_borrar_ala';

	// Pantalla Contenidos
	static readonly Constante_Contenidos_add_contenido = 'Contenidos_add_contenido';
	static readonly Constante_Contenidos_editar_contenido = 'Contenidos_editar_contenido';
	static readonly Constante_Contenidos_borrar_contenido = 'Contenidos_borrar_contenido';
	static readonly Constante_Contenidos_exportar_contenido = 'Contenidos_exportar_contenido';
	static readonly Constante_Contenidos_importar_contenido = 'Contenidos_importar_contenido';

	// Pantalla Encuestas
	static readonly Constante_Encuestas_exportar_encuesta = 'Encuestas_exportar_encuesta';

	// Modelo3D
	static readonly Constante_Contenido_modelo_3d = 'Contenido_modelo_3d';

	// Pantalla Ruta Sugerida
	static readonly Constante_RutaSugerida_add_ruta= 'RutaSugerida_add_ruta';
	static readonly Constante_RutaSugerida_editar_ruta = 'RutaSugerida_editar_ruta';
	static readonly Constante_RutaSugerida_borrar_ruta = 'RutaSugerida_borrar_ruta';

	// Pantalla Mensajes
	static readonly Constante_Mensajes_ver_mensaje= 'Mensajes_ver_mensaje';
	static readonly Constante_Mensajes_enviar_mensaje = 'Mensajes_enviar_mensaje';
	static readonly Constante_Mensajes_ver_detalle_mensaje = 'Mensajes_ver_detalle_mensaje';
	static readonly Constante_Mensajes_enviar_mensaje_visisitado = 'Mensajes_enviar_mensaje_visisitado';
	static readonly Constante_Mensajes_enviar_mensaje_explorado = 'Mensajes_enviar_mensaje_explorado';
	static readonly Constante_Mensajes_enviar_mensaje_tiene_app = 'Mensajes_enviar_mensaje_tiene_app';

	// Perfil Movilidad
	static readonly Constante_Ajustes_add_Perfil = 'Ajustes_add_Perfil';
	static readonly Constante_Ajustes_editar_Perfil = 'Ajustes_editar_Perfil';
	static readonly Constante_Ajustes_borrar_Perfil = 'Ajustes_borrar_Perfil';

	// Tipologia
	static readonly Constante_Ajustes_add_Tipologia = 'Ajustes_add_Tipologia';
	static readonly Constante_Ajustes_editar_Tipologia = 'Ajustes_editar_Tipologia';
	static readonly Constante_Ajustes_borrar_Tipologia = 'Ajustes_borrar_Tipologia';
	static readonly Constante_Tipologia_Contenido_Localizable_Crear = 'Tipologia_Contenido_Localizable_Crear';

	// Usuarios
	static readonly Constante_Ajustes_add_Usuarios = 'Ajustes_add_Usuarios';
	static readonly Constante_Ajustes_editar_Usuarios = 'Ajustes_editar_Usuarios';
	static readonly Constante_Ajustes_borrar_Usuarios = 'Ajustes_borrar_Usuarios';

	// Pantalla Espacios
	static readonly Constante_Selector_Espacio_add_espacio = 'Selector_Espacio_add_espacio';
	static readonly Constante_Selector_Espacio_editar_espacio = 'Selector_Espacio_editar_espacio';
	static readonly Constante_Selector_Espacio_borrar_espacio = 'Selector_Espacio_borrar_espacio';

	// Activos
	static readonly Constante_Gestion_Activos = 'Gestion_Activos';

	// TIPOLOGIA_SECCION
	static readonly Constante_Ajustes_add_Tipologia_Seccion = 'Ajustes_add_Tipologia_Seccion';
	static readonly Constante_Ajustes_editar_Tipologia_Seccion = 'Ajustes_editar_Tipologia_Seccion';
	static readonly Constante_Ajustes_borrar_Tipologia_Seccion = 'Ajustes_borrar_Tipologia_Seccion';

	/* permisos Tipologia_Seccion*/
	Ajustes_add_Tipologia_Seccion = 0;
	Ajustes_editar_Tipologia_Seccion = 0;
	Ajustes_borrar_Tipologia_Seccion = 0;

	/* Permisos SelectorMapasComponent */
	Selector_Mapa_add_nivel = 0;
	Selector_Mapa_editar_nivel = 0;
	Selector_Mapa_borrar_nivel = 0;

	Selector_Mapa_add_ala = 0;
	Selector_Mapa_editar_ala = 0;
	Selector_Mapa_borrar_ala = 0;

	/* Permisos Espacio*/
	Selector_Espacio_add_espacio = 0;
	Selector_Espacio_editar_espacio = 0;
	Selector_Espacio_borrar_espacio = 0;


	/* Permisos mapas.component */
	Mapa_crear_plano = 0;
	Mapa_plano_nodo = 0;
	Mapa_plano_seccion = 0;
	Mapa_plano_contenido = 0;
	Mapa_plano_conexion = 0;

	Mapa_plano_nodo_formulario = 0;
	Mapa_plano_seccion_formulario = 0;
	Mapa_plano_contenido_formulario = 0;
	Mapa_plano_conexion_formulario = 0;
	Mapa_plano_cortar_conexion_formulario = 0;
	Mapa_plano_eliminar_conexion_formulario = 0;
	Mapa_plano_balizas = 0;
	Mapa_plano_baliza_formulario = 0;
	Mapa_plano_baliza_password = 0;
	Mapa_plano_Preview_por_Fecha = 0;

	/* permisos Contenido */
	Contenidos_add_contenido = 0;
	Contenidos_editar_contenido = 0;
	Contenidos_borrar_contenido = 0;
 	Contenidos_exportar_contenido = 0;
	Contenidos_importar_contenido = 0;
	Contenido_modelo_3d = 0;

	/* permisos encuesta */
 	Encuestas_exportar_encuesta = 0;

	// Pantalla Ruta Sugerida
	RutaSugerida_add_ruta= 0;
	RutaSugerida_editar_ruta = 0;
	RutaSugerida_borrar_ruta = 0;

	// Pantalla Mensajes
	Mensajes_ver_mensaje= 0;
	Mensajes_enviar_mensaje = 0;
	Mensajes_ver_detalle_mensaje = 0;
	Mensajes_enviar_mensaje_visisitado = 0;
	Mensajes_enviar_mensaje_explorado = 0;
	Mensajes_enviar_mensaje_tiene_app = 0;

	// Perfil Movilidad
	Ajustes_add_Perfil = 0;
	Ajustes_editar_Perfil = 0;
	Ajustes_borrar_Perfil = 0;

	// Tipologia
	Ajustes_add_Tipologia = 0;
	Ajustes_editar_Tipologia = 0;
	Ajustes_borrar_Tipologia = 0;
	Tipologia_Contenido_Localizable_Crear = 0;
	// Usuarios
	Ajustes_add_Usuarios = 0;
	Ajustes_editar_Usuarios = 0;
	Ajustes_borrar_Usuarios = 0;

	// Activos
	Gestion_Activos = 0;


	constructor(funcionalidades?: any) {

		if (funcionalidades) {
			funcionalidades.forEach(funcion => {
				if (funcion.FUNCIONALIDAD) {

					/* SelectorMapasComponent */
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Selector_Mapa_add_nivel) {
						this.Selector_Mapa_add_nivel = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Selector_Mapa_editar_nivel) {
						this.Selector_Mapa_editar_nivel = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Selector_Mapa_borrar_nivel) {
						this.Selector_Mapa_borrar_nivel = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Selector_Mapa_add_ala) {
						this.Selector_Mapa_add_ala = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Selector_Mapa_editar_ala) {
						this.Selector_Mapa_editar_ala = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Selector_Mapa_borrar_ala) {
						this.Selector_Mapa_borrar_ala = funcion.Tipo;
					}

					/* mapasComponent */
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Mapa_crear_plano) {
						this.Mapa_crear_plano = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Mapa_plano_nodo) {
						this.Mapa_plano_nodo = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Mapa_plano_seccion) {
						this.Mapa_plano_seccion = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Mapa_plano_contenido) {
						this.Mapa_plano_contenido = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Mapa_plano_conexion) {
						this.Mapa_plano_conexion = funcion.Tipo;
					}
					if(funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Mapa_plano_Preview_por_Fecha){
						this.Mapa_plano_Preview_por_Fecha = funcion.Tipo;
					}

					// Formularios
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Mapa_plano_nodo_formulario) {
						this.Mapa_plano_nodo_formulario = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Mapa_plano_seccion_formulario) {
						this.Mapa_plano_seccion_formulario = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Mapa_plano_contenido_formulario) {
						this.Mapa_plano_contenido_formulario = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Mapa_plano_conexion_formulario) {
						this.Mapa_plano_conexion_formulario = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Mapa_plano_cortar_conexion_formulario) {
						this.Mapa_plano_cortar_conexion_formulario = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Mapa_plano_eliminar_conexion_formulario) {
						this.Mapa_plano_eliminar_conexion_formulario = funcion.Tipo;
					}

					/* Balizas en Mapa*/
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Mapa_plano_balizas) {
						this.Mapa_plano_balizas = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Mapa_plano_baliza_formulario) {
						this.Mapa_plano_baliza_formulario = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Mapa_plano_baliza_password) {
						this.Mapa_plano_baliza_password = funcion.Tipo;
					}

					/* permisos Contenido */
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Contenidos_add_contenido) {
						this.Contenidos_add_contenido = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Contenidos_editar_contenido) {
						this.Contenidos_editar_contenido = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Contenidos_borrar_contenido) {
						this.Contenidos_borrar_contenido = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Contenidos_exportar_contenido) {
						this.Contenidos_exportar_contenido = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Contenidos_importar_contenido) {
						this.Contenidos_importar_contenido = funcion.Tipo;
					}

					/* permisos Encuesta */
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Encuestas_exportar_encuesta) {
						this.Encuestas_exportar_encuesta = funcion.Tipo;
					}

					//Modelo3D
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Contenido_modelo_3d) {
						this.Contenido_modelo_3d = funcion.Tipo;
					}

					// Pantalla Ruta Sugerida
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_RutaSugerida_add_ruta) {
						this.RutaSugerida_add_ruta = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_RutaSugerida_editar_ruta) {
						this.RutaSugerida_editar_ruta = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_RutaSugerida_borrar_ruta) {
						this.RutaSugerida_borrar_ruta = funcion.Tipo;
					}

					// Pantalla Mensajes
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Mensajes_ver_mensaje) {
						this.Mensajes_ver_mensaje = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Mensajes_enviar_mensaje) {
						this.Mensajes_enviar_mensaje = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Mensajes_ver_detalle_mensaje) {
						this.Mensajes_ver_detalle_mensaje = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Mensajes_enviar_mensaje_visisitado) {
						this.Mensajes_enviar_mensaje_visisitado = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Mensajes_enviar_mensaje_explorado) {
						this.Mensajes_enviar_mensaje_explorado = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Mensajes_enviar_mensaje_tiene_app) {
						this.Mensajes_enviar_mensaje_tiene_app = funcion.Tipo;
					}

					// Perfil Movilidad
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Ajustes_add_Perfil) {
						this.Ajustes_add_Perfil = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Ajustes_editar_Perfil) {
						this.Ajustes_editar_Perfil = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Ajustes_borrar_Perfil) {
						this.Ajustes_borrar_Perfil = funcion.Tipo;
					}

					// Tipologia
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Ajustes_add_Tipologia) {
						this.Ajustes_add_Tipologia = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Ajustes_editar_Tipologia) {
						this.Ajustes_editar_Tipologia = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Ajustes_borrar_Tipologia) {
						this.Ajustes_borrar_Tipologia = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Tipologia_Contenido_Localizable_Crear){
						this.Tipologia_Contenido_Localizable_Crear = funcion.Tipo;
					}

					// Usuarios
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Ajustes_add_Usuarios) {
						this.Ajustes_add_Usuarios = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Ajustes_editar_Usuarios) {
						this.Ajustes_editar_Usuarios = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Ajustes_borrar_Usuarios) {
						this.Ajustes_borrar_Usuarios = funcion.Tipo;
					}

					// Pantalla Espacios
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Selector_Espacio_add_espacio) {
						this.Selector_Espacio_add_espacio = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Selector_Espacio_editar_espacio) {
						this.Selector_Espacio_editar_espacio = funcion.Tipo;
					}
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Selector_Espacio_borrar_espacio) {
						this.Selector_Espacio_borrar_espacio = funcion.Tipo;
					}

					// Activos
					if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Gestion_Activos) {
						this.Gestion_Activos = funcion.Tipo;
					}

						// TIPOLOGIA_SECCION
						if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Ajustes_add_Tipologia_Seccion) {
							this.Ajustes_add_Tipologia_Seccion = funcion.Tipo;
						}
						if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Ajustes_editar_Tipologia_Seccion) {
							this.Ajustes_editar_Tipologia_Seccion = funcion.Tipo;
						}
						if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Ajustes_borrar_Tipologia_Seccion) {
							this.Ajustes_borrar_Tipologia_Seccion = funcion.Tipo;
						}
				}
			});
		}

	}


}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/providers/authentication/permisos.service.ts